import {Button} from 'antd'
import {medal_getMedals_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {branch, compose, fromRenderProps} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {MedalsSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import renderMedal from "../../Medal/renderMedal";
import MedalFilter from "../../Medal/MedalFilter";
import WorkspaceContext from "../../WorkspaceContext";
import {useMedalManager} from "../../Medal/userMedalManager";
import {SectionTemplate} from "../../Workspace";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import classNames from "classnames";


const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const CourseMedals = ({
                          owner_id,
                          owner_type,
                          Wrapper = 'div',
                          filter_actions = {
                              sortBy: 'sort-by',
                              keyword: 'keyword',
                              active: 'active',
                          },
                      }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const active = useRouteSearchParam(filter_actions.active)

    const {
        refreshKey,
        modal = null,
        handleAction = NullAsDefault,
    } = useMedalManager({
        owner_id,
        owner_type,
    })

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CRUD.UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CRUD.DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const [pager_widget] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                active,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            apiInfo: medal_getMedals_Api,
            RenderEntity: React.Fragment,
            PaginationMeta: renderGridMeta,
            renderItem: renderMedal({
                renderContextMenu,
            }),
            query: bindQueryParams([{id: owner_id}, {prop: owner_type}]),
            renderWrap: (child, __, count) => !!count
                ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {child}
                    </div>
                )
                : (
                    <div className="flex flex-col gap-6">
                        {child}
                    </div>
                ),
        },
        // sortHeader: t('course certificates'),
        sortHeader: null,
        SortByWidget: MedalsSortBy,
        AdvancedFilter: MedalFilter,
        query_params: filter_actions,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })

    return (
        <Wrapper className="flex flex-col space-y-3">
            <SectionTemplate
                title={t("course certificates")}
                description={t("course certificates description")}
                actionText={t("create certificates")}
                renderActionButton={() => (
                    <Button
                        color="primary" variant="solid"
                        className="mt-6 px-6 py-2 text-white rounded-lg shadow-md transition hover:scale-xs"
                        onClick={() => {
                            handleAction(CRUD.CREATE)
                        }}>
                        {t("create certificates")}
                    </Button>
                )}
            />
            {pager_widget}
            {modal}
            <div className="h-10"/>
        </Wrapper>
    )
}

export default compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        owner_id: getId(organization),
        owner_type: getType(organization),
    })),
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], (e) => !e),
        () => () => <ContentNotFound/>
    )
)(CourseMedals)
